import { fromJS, isImmutable } from 'immutable';
export const getSelections = (state) => state.getIn(['editorState', 'selections']).toJS();
export const foldSelections = (state) => state.getIn(['editorState', 'selections']).reduce((a, c) => a.merge(isImmutable(c) ? c.get('data') : c.data), fromJS({})).toJS();
